import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { Container, Card, CardBody, Nav, NavItem, NavLink } from "reactstrap"
import classnames from "classnames"
import { withRouter } from "react-router"

import { withTranslation } from "react-i18next"
import AddQuart from "./AddQuart";
import DataTableQuart from "./DataTableQuart"

const Quart = props => {
  const [section, setSection] = useState(1)

  const back = () => {
    setSection(1)
  }

  const renderBlock = section => {
    if (section === 1) {
      return <DataTableQuart />
    } else if (section === 2) {
      return <AddQuart setSection={setSection} back={back} />
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{props.t("Quart")} | Cresus </title>
        </MetaTags>
        <Container fluid>
          <div>
            <Nav tabs>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: section === 1,
                  })}
                  onClick={() => {
                    setSection(1)
                  }}
                >
                  {props.t("Quart")}
                </NavLink>
              </NavItem>
              {/*<NavItem>*/}
              {/*  <NavLink*/}
              {/*    style={{ cursor: "pointer" }}*/}
              {/*    className={classnames({*/}
              {/*      active: section === 2,*/}
              {/*    })}*/}
              {/*    onClick={() => {*/}
              {/*      setSection(2)*/}
              {/*    }}*/}
              {/*  >*/}
              {/*    {props.t("Ajouter")} {props.t("Quart Examen")}*/}
              {/*  </NavLink>*/}
              {/*</NavItem>*/}
            </Nav>
            <Card>
              <CardBody>{renderBlock(section)}</CardBody>
            </Card>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(withTranslation()(Quart))
Quart.propTypes = {
  t: PropTypes.any,
}
